import { PublicClientApplication, type IPublicClientApplication, Configuration, LogLevel } from "@azure/msal-browser";

function readEnv(name: "REACT_APP_ENTRA_CLIENT_ID" | "REACT_APP_ENTRA_TENANT_ID"): string {
  const raw = process.env[name] || "";
  const commentStart = raw.indexOf(" #");
  const withoutInlineComment = (commentStart >= 0 ? raw.slice(0, commentStart) : raw).trim();
  return withoutInlineComment.replace(/^['"]|['"]$/g, "").trim();
}

const entraClientId = readEnv("REACT_APP_ENTRA_CLIENT_ID");
const entraTenantId = readEnv("REACT_APP_ENTRA_TENANT_ID");

const msalConfig: Configuration = {
  auth: {
    clientId: entraClientId,
    authority: `https://login.microsoftonline.com/${entraTenantId}`,
    redirectUri: window.location.origin + "/callback",
  },
  cache: {
    cacheLocation: "localStorage",
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error("MSAL Error:", message);
            break;
          case LogLevel.Warning:
            console.warn("MSAL Warning:", message);
            break;
          case LogLevel.Info:
            console.info("MSAL Info:", message);
            break;
          default:
            break;
        }
      },
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

// MSAL 5+ requires explicit initialization before token operations.
export const msalInitialization = msalInstance.initialize();

export async function ensureMsalInitialized(instance?: IPublicClientApplication): Promise<void> {
  const target = instance || msalInstance;
  if (target === msalInstance) {
    await msalInitialization;
    return;
  }
  await target.initialize();
}

// Scopes for token request
export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};

// Redirect to /callback after auth code exchange
export const tokenRequest = {
  scopes: ["openid", "profile", "email"],
};
